import { render, staticRenderFns } from "./mdmselect.vue?vue&type=template&id=028f5f4a"
import script from "./mdmselect.vue?vue&type=script&lang=js"
export * from "./mdmselect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports